import { useState, useEffect } from "react";
import Logo from "../img/Logotipo.webp";
import imgNav from "../img/fondo1.webp";
import { motion } from "framer-motion";
import { showSuccess } from "./Utils/toastUtils";

import img3 from "../img/HotDogs/3.webp";
import img4 from "../img/HotDogs/4.webp";
import img5 from "../img/HotDogs/5.webp";
import img6 from "../img/HotDogs/6.webp";

const promos = [
  { id: 1, img: img3, nombre: "CHEDDAR MELT", precio: 6.49 },
  { id: 2, img: img4, nombre: "CLASSIC BACON", precio: 6.99 },
  { id: 3, img: img5, nombre: "CLASSIC", precio: 6.00 },
  { id: 4, img: img6, nombre: "ESPECIAL", precio: 5.00 },
];

const PromoHotDog = ({ onAgregarPromo, onSiguiente }) => {
  const [loading, setLoading] = useState(true);
  const [imgsLoaded, setImgsLoaded] = useState(0);
  const [selectedPromoId, setSelectedPromoId] = useState(null);

  const totalImages = promos.length + 2; 

  useEffect(() => {
    const timeout = setTimeout(() => {
        setLoading(false);
    }, 3000);

    if (imgsLoaded >= totalImages) {
      setLoading(false);
      clearTimeout(timeout);
    }
    return () => clearTimeout(timeout);
  }, [imgsLoaded, totalImages]);

  const handleClickPromo = (promo) => {
    setSelectedPromoId(prev => (prev === promo.id ? null : promo.id));
  };

  const handleAgregar = (promo) => {
    // Enriquecer la promo con el tipo antes de mandar a agregar
    const promoConTipo = { ...promo, tipoModulo: "hd" };
    if (onAgregarPromo) onAgregarPromo(promoConTipo);
    showSuccess(`${promo.nombre} agregado!`);
    setSelectedPromoId(null);
  };

  return (
    <div className="min-h-screen !bg-transparent p-8 sm:p-8 rounded-2xl w-full flex flex-col items-center px-3 py-3 -mt-12 relative overflow-hidden">
      {/* Fondo del contenido modal con z-index corregido */}
      <img 
        src={imgNav} 
        alt="Fondo" 
        className="absolute inset-0 w-full h-full object-cover -z-10 pointer-events-none" 
        onLoad={() => setImgsLoaded(prev => prev + 1)}
        onError={() => setImgsLoaded(prev => prev + 1)} 
      />

      {loading && (
        <motion.div
          key="loader"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="absolute inset-0 flex flex-col items-center justify-center !bg-transparent rounded-2xl z-50 pointer-events-none"
        >
          <div className="w-16 h-16 border-4 border-neutral-200 border-t-transparent rounded-full animate-spin"></div>
        </motion.div>
      )}

      <div className={`${loading ? "pointer-events-none select-none opacity-0" : "opacity-100 transition-opacity duration-500"} w-full flex flex-col items-center !bg-transparent`}>
        <img
          src={Logo}
          alt="Logo"
          className="w-32 mx-auto"
          style={{ objectFit: "contain" }}
          onLoad={() => setImgsLoaded(prev => prev + 1)}
          onError={() => setImgsLoaded(prev => prev + 1)}
        />

        <h1 className="text-3xl font-bold mb-4 -mt-4 uppercase text-center">
          <span className="text-black">390 Hot</span>{" "}
          <span className="text-red-600">Dog</span>{" "}
          <span className="text-yellow-400">Duo</span>
        </h1>
        <h2 className="text-black/50 text-sm font-bold mb-4 -mt-4">
          Para agregar un duo, solo presiona.
        </h2>

        <div className="w-full max-w-md flex flex-wrap justify-between items-center bg-transparent">
          {promos.map((promo, index) => (
            <div
              key={promo.id}
              className="flex flex-col items-center cursor-pointer w-[45%] relative bg-transparent"
              style={{ marginTop: index >= 2 ? "-3rem" : "0" }}
              onClick={() => handleClickPromo(promo)}
            >
              <div className="bg-white rounded-lg px-2 py-1 shadow-md z-20 flex flex-col items-center min-w-[80%]">
                <p className="text-red-600 text-[9px] sm:text-[10px] text-center font-extrabold leading-tight uppercase tracking-tighter">
                  {promo.nombre}
                </p>
                <div className="text-black text-center text-[10px] sm:text-xs font-black">
                  $ {promo.precio}
                </div>
              </div>
              
              <div className="relative w-full bg-transparent">
                <div className="relative -mt-[40px] flex items-center justify-center min-h-[120px] bg-transparent">
                  <img
                    src={promo.img}
                    alt={promo.nombre}
                    className={`w-full h-auto object-contain rounded-md transition-opacity duration-300 ${
                      selectedPromoId === promo.id ? "opacity-0 pointer-events-none" : "opacity-100"
                    }`}
                    onLoad={() => setImgsLoaded((prev) => prev + 1)}
                    onError={() => setImgsLoaded((prev) => prev + 1)}
                  />

                  {selectedPromoId === promo.id && (
                    <div className="absolute inset-0 flex items-center justify-center">
                      <button
                        className="bg-yellow-500 text-white font-bold py-2 px-6 rounded-full shadow-lg z-30"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleAgregar(promo);
                        }}
                      >
                        Agregar
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="w-full flex justify-center items-center mt-[-1rem] pb-8">
          <button
            className="bg-yellow-500 text-white font-bold py-2 px-10 rounded-xl hover:bg-yellow-400 transition shadow-lg"
            onClick={onSiguiente}
          >
            Siguiente
          </button>
        </div>
      </div>
      
      {/* Estilos inyectados al final para forzar la transparencia del modal padre de ModalInicio */}
      <style>{`
        .bg-white.rounded-2xl.w-\\[90\\%\\].max-w-sm.sm\\:max-w-md.lg\\:max-w-lg.max-h-\\[80vh\\] {
          background: transparent !important;
          box-shadow: none !important;
        }
      `}</style>
    </div>
  );
};

export default PromoHotDog;
